import { render } from "./NewPlan.vue?vue&type=template&id=6076fee5"
const script = {}
script.render = render

export default script